(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}

  function initGallery(root){
    if (root.__pgInit) return; root.__pgInit = true;

    const track  = root.querySelector('.pg-track');
    const slides = Array.from(root.querySelectorAll('.pg-slide'));
    const dots   = Array.from(root.querySelectorAll('.pg-dot'));
    const thumbs = Array.from(root.querySelectorAll('.pg-thumb'));
    const prev   = root.querySelector('.pg-prev');
    const next   = root.querySelector('.pg-next');

    function goTo(i){
      const idx = Math.max(0, Math.min(i, slides.length - 1));
      const target = slides[idx];
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function activeIndex(){
      const x = track.scrollLeft;
      let best = 0, bestDelta = Infinity;
      slides.forEach((sl,i)=>{
        const delta = Math.abs(sl.offsetLeft - x);
        if (delta < bestDelta){ bestDelta = delta; best = i; }
      });
      return best;
    }

    function syncUI(i){
      dots.forEach((d,idx)=> d.classList.toggle('is-active', idx===i));
      thumbs.forEach((t,idx)=> t.classList.toggle('is-active', idx===i));
    }

    // Controls
    prev && prev.addEventListener('click', ()=> goTo(activeIndex()-1));
    next && next.addEventListener('click', ()=> goTo(activeIndex()+1));
    thumbs.forEach((t,idx)=> t.addEventListener('click', ()=> goTo(idx)));

    // Update on scroll (RAF debounce)
    let rafId=null;
    track.addEventListener('scroll', ()=>{
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(()=> syncUI(activeIndex()));
    });

    // Initial sync after first image loads
    const img0 = slides[0]?.querySelector('img');
    const bump = ()=> syncUI(0);
    if (img0){ img0.complete ? bump() : img0.addEventListener('load', bump, {once:true}); }

    // Variant → image sync
    function slideToImageId(imgId){
      const idx = slides.findIndex(sl => sl.dataset.imageId === String(imgId));
      if (idx >= 0) goTo(idx);
    }
    document.addEventListener('variant:changed', function(e){
      const v = e.detail && e.detail.variant;
      if (v && v.featured_image && v.featured_image.id) slideToImageId(v.featured_image.id);
    });

    // Fallback: listen to variant <select>
    const select = root.closest('form')?.querySelector('select[name="id"]') ||
                   document.querySelector('form[action="/cart/add"] select[name="id"]');
    if (select){
      const productId = (root.id||'').replace('pg-', '').replace('pg-bottom-', '');
      const variants = window.productVariants && window.productVariants[productId];
      select.addEventListener('change', ()=>{
        if (!variants) return;
        const v = variants.find(v=> String(v.id)===String(select.value));
        if (v && v.featured_image && v.featured_image.id) slideToImageId(v.featured_image.id);
      });
    }
  }

  function initAll(ctx){
    (ctx||document).querySelectorAll('.product-gallery').forEach(initGallery);
  }

  ready(function(){
    initAll(document);
    document.addEventListener('shopify:section:load', e=> initAll(e.target));
    document.addEventListener('shopify:section:select', e=> initAll(e.target));
  });
})();
